'use client';
import { Divider } from '@snack-uikit/divider';
import { Typography } from '@snack-uikit/typography';

import { CURRENT_YEAR } from '@/constant/common';
import { getGlobalArgs } from '@/root/global';

import { LinkWrapper } from '../LinkWrapper';
import s from './styles.module.scss';
import { RightItem, rights } from './utils';

const Right = ({ label, link }: RightItem) => (
  <LinkWrapper
    target={'_blank'}
    textWrapper={() => <Typography.SansBodyM className={s.item_text}> {label} </Typography.SansBodyM>}
    link={link}
  />
);

export function CopyRights() {
  return (
    <div className={s.copyrights_wrapper}>
      <Divider />
      <div className={s.base_copyrights_wrapper}>
        {rights.common.map(({ label, link }) => (
          <Right key={label} label={label} link={link} />
        ))}
      </div>
      <Right link={getGlobalArgs('NEXT_PUBLIC_CONTENT_BASE_URL', '')} label={`© ${CURRENT_YEAR} Cloud.ru`} />
    </div>
  );
}
